<template>
  <div class="body simple-not-found">
    <div class="content">
      <h1>404</h1>
      <h2>{{ $t('notFound.title') }}</h2>
      <p>{{ $t('notFound.message') }}</p>
      <div class="actions">
        <button @click="goHome" class="btn-home">{{ $t('notFound.go_home') }}</button>
        <!-- <button @click="goBack" class="btn-back" v-if="canGoBack">{{ $t('notFound.go_back') }}</button> -->
      </div>
    </div>
  </div>
</template>

<script>
import { useRouter } from 'vue-router'
import { computed } from 'vue'

export default {
  name: 'SimpleNotFound',
  setup() {
    const router = useRouter()
    const canGoBack = computed(() => window.history.length > 2)

    const goHome = () => {
      router.push('/')
    }

    const goBack = () => {
      router.go(-1)
    }

    return {
      canGoBack,
      goHome,
      goBack
    }
  }
}
</script>

<style scoped>
.simple-not-found {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: var(--bg);
  padding: 20px;
}

.content {
  text-align: center;
  max-width: 500px;
  width: 100%;
  padding: 40px;
  background: var(--card-bg);
  border-radius: 10px;
  box-shadow: 0 5px 15px var(--shadow-1);
  border: 1px solid var(--card-border);
}

.content h1 {
  font-size: 6rem;
  color: var(--orange-1);
  margin: 0;
  font-weight: 900;
}

.content h2 {
  font-size: 1.8rem;
  color: var(--heading);
  margin: 10px 0;
}

.content p {
  color: var(--subtext);
  margin-bottom: 30px;
  font-size: 1.1rem;
  line-height: 1.6;
}

.actions {
  display: flex;
  gap: 15px;
  justify-content: center;
  flex-wrap: wrap;
}

.btn-home, .btn-back {
  padding: 12px 24px;
  border: none;
  border-radius: 5px;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 600;
}

.btn-home {
  background: var(--primary);
  color: white;
}

.btn-home:hover {
  background: var(--primary-hover);
  transform: translateY(-2px);
}

.btn-back {
  background: var(--muted);
  color: white;
}

.btn-back:hover {
  background: var(--muted-2);
  transform: translateY(-2px);
}

@media (max-width: 480px) {
  .content h1 {
    font-size: 4rem;
  }
  
  .content h2 {
    font-size: 1.5rem;
  }
  
  .actions {
    flex-direction: column;
  }
  
  .btn-home, .btn-back {
    width: 100%;
  }
}
</style>